export default __webpack_public_path__ + "static/media/carwash.9cc5056f.png";